/**
 * @generated SignedSource<<f7368b67c521de1784f5fa32a0dd272d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MoveAnswerInput = {
  answerId: string;
  clientMutationId?: string | null;
  toPosition?: number | null;
};
export type ActiveElementContent_MoveAnswer_Mutation$variables = {
  input: MoveAnswerInput;
};
export type ActiveElementContent_MoveAnswer_Mutation$data = {
  readonly moveAnswer: {
    readonly element: {
      readonly answers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly dbId: string;
            readonly id: string;
            readonly position: number;
            readonly text: string | null;
          } | null;
        } | null>;
      };
      readonly id: string;
    } | null;
  } | null;
};
export type ActiveElementContent_MoveAnswer_Mutation = {
  response: ActiveElementContent_MoveAnswer_Mutation$data;
  variables: ActiveElementContent_MoveAnswer_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MoveAnswerPayload",
    "kind": "LinkedField",
    "name": "moveAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ElementNode",
        "kind": "LinkedField",
        "name": "element",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AnswerNodeConnection",
            "kind": "LinkedField",
            "name": "answers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AnswerNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AnswerNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dbId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "position",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActiveElementContent_MoveAnswer_Mutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActiveElementContent_MoveAnswer_Mutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "42c0dd64bfe01197cbb5197afc8cf946",
    "id": null,
    "metadata": {},
    "name": "ActiveElementContent_MoveAnswer_Mutation",
    "operationKind": "mutation",
    "text": "mutation ActiveElementContent_MoveAnswer_Mutation(\n  $input: MoveAnswerInput!\n) {\n  moveAnswer(input: $input) {\n    element {\n      id\n      answers {\n        edges {\n          node {\n            id\n            dbId\n            position\n            text\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "930fb2ed12c19398de18e2658d5cae6f";

export default node;
